import { render, staticRenderFns } from "./researcher.vue?vue&type=template&id=8def9214&scoped=true"
import script from "./researcher.vue?vue&type=script&lang=js"
export * from "./researcher.vue?vue&type=script&lang=js"
import style0 from "./researcher.vue?vue&type=style&index=0&id=8def9214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8def9214",
  null
  
)

export default component.exports